import cookieManagerValidated from "./class.cookieManagerVallidated.js";
import cookieManager from "./class.cookieManager.js";
import { updateMobileLinks } from "./updateMobileLinks.js";

var irClickTracking = new cookieManager("rentalz-irclickid", "irclickid");
var affiliateTracking = new cookieManagerValidated("rentalz-aff", "ref");

// re: using parcel - https://roots.io/developing-gutenberg-blocks-with-parcel-js-and-astroturf/
// re: postcss nested - https://jonathanmh.com/parcel-js-postcss-rule-nesting/
document.addEventListener("DOMContentLoaded", function (event) {
  //  rentalzAffiliateTracking.refManager();
  //  irClickId();

  // All pages need a phone number
  // affiliateID.phoneNumber(); // adds the phone number to the page

  // is this a Destination page
  if (null != document.getElementById("destination-modal")) {
    if (affiliateTracking.recall()) {
      updateMobileLinks("ref", affiliateTracking.recall().code);
      updateMobileLinks("irclickid", irClickTracking.recall());
    }
  }

  // or is this a Market page
  if (null != document.getElementById("icnd-search")) {
    let ICNDsearchRefField = document.getElementById("ref");
    if (null != ICNDsearchRefField && affiliateTracking.recall()) {
      ICNDsearchRefField.value = affiliateTracking.recall().code;
    }

    let ICNDsearchIRClickField = document.getElementById("irclickid");
    if (null != ICNDsearchIRClickField) {
      ICNDsearchIRClickField.value = irClickTracking.recall();
    }
    /**
     * Is there a book.rentalz.com link in the blurbs
     */
    let blurbs = document.querySelectorAll(".rentalz-blurbs li a");
    for (const blurb of blurbs) {
      if (blurb.href.startsWith("https://book.rentalz.com/")) {
        let url = new URL(blurb.href);
        if (affiliateTracking.recall())
          url.searchParams.set("ref", affiliateTracking.recall().code);
        url.searchParams.set("irclickid", irClickTracking.recall());
        blurb.href = url.href;
        console.log(blurb, url.href);
      }
    }
  }

  /**
   * Ready to display the phone number - regardless of page type
   */
  if (
    affiliateTracking.recall() &&
    null !== affiliateTracking.recall().code &&
    null != affiliateTracking.recall().phonenumber
  ) {
    let phoneNumbers = document.getElementsByClassName("aff-phone-number-text");
    for (var i = 0; i < phoneNumbers.length; i++) {
      phoneNumbers[i].innerHTML = affiliateTracking.recall().phonenumber;
      console.log("update", phoneNumbers[i]);
    }

    let phoneLinks = document.getElementsByClassName("aff-phone-number-link");
    if (phoneLinks.length)
      for (var i = 0; i < phoneLinks.length; i++) {
        phoneLinks[i].href = "tel:+1" + affiliateTracking.recall().phonenumber;
      }
    /*
    let phoneFooter = document
      .getElementsByClassName("rentalz-phone-header")[0]
      .getElementsByTagName("a")[0];
    phoneFooter.href = "tel:+1" + affiliateTracking.recall().phonenumber;
    phoneFooter.textContent = affiliateTracking.recall().phonenumber;
    */
  }

  document
    .getElementsByClassName("be-header-phone-number")[0]
    .classList.add("ready");
});

function affiliateURLdecorator(url) {
  let urlObject = new URL(url);
  if (affiliateTracking.recall()) {
    if (
      undefined !== affiliateTracking.recall().code &&
      null !== affiliateTracking.recall().code &&
      "" !== affiliateTracking.recall().code
    )
      urlObject.searchParams.set("ref", affiliateTracking.recall().code);
  }

  if (
    undefined !== irClickTracking.recall() &&
    null !== irClickTracking.recall() &&
    "" !== irClickTracking.recall()
  )
    urlObject.searchParams.set("irclickid", irClickTracking.recall());

  console.log(url, urlObject.href);
  return urlObject.href;
}
window.affiliateURLdecorator = affiliateURLdecorator;
